import { render, staticRenderFns } from "./ParameterRow.vue?vue&type=template&id=6630d128&scoped=true&"
import script from "./ParameterRow.vue?vue&type=script&lang=js&"
export * from "./ParameterRow.vue?vue&type=script&lang=js&"
import style0 from "./ParameterRow.vue?vue&type=style&index=0&id=6630d128&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6630d128",
  null
  
)

export default component.exports